import React from "react"
import { useTranslation } from "react-i18next"
import { faExclamationTriangle, faRegistered } from "@fortawesome/free-solid-svg-icons"
import { TitleChildrenPath } from "../Titles/Titles"
import Button from "../Button/Button"
import Animate, { AnimationTypes } from "../Animate/Animate"
import ModalPortal from "../Modal/ModalPortal"
import defalutStyle from "../../styles/defaultPageStyle.module.css"
import THEME from "../../configuration/Theme"

interface ConfirmationPopupProps {
  message: string
  title: string
  onConfirmation: () => void
  onClose: () => void
}

export const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({ message, title, onConfirmation, onClose }) => {
  const { t } = useTranslation("components")

  return (
    <ModalPortal>
      <div className={defalutStyle.overlay}>
        <Animate type={AnimationTypes.slideUpIn} duration="0.3s">
          <div className={defalutStyle.alert1}>
            <TitleChildrenPath
              iconColor="#ea580c"
              icon={faRegistered}
              boxShadow="none"
              title={t("label_register_notify")}
              children={
                <>
                  <div className="mt-4" />

                  <TitleChildrenPath
                    iconColor={THEME.colors.iconBGColor}
                    icon={faExclamationTriangle}
                    title={title}
                    path={message}
                    boxShadow="none"
                    children={
                      <>
                        <div className="mt-8 flex justify-center gap-3">
                          <Button
                            type="primary"
                            typeButton="button"
                            size="medium"
                            label={t("buttons:button_confirm")}
                            animationTypes={AnimationTypes.fadeIn}
                            bgColor="#ea580c"
                            onClick={() => {
                              onConfirmation()

                              onClose()
                            }}
                            descriptionKey="interactionDescriptions:components.confirmationPopup.confirmationPopup.button.confirm"
                          />

                          <Button
                            typeButton="button"
                            type="primary"
                            size="medium"
                            label={t("buttons:button_cancel")}
                            animationTypes={AnimationTypes.fadeIn}
                            bgColor="#dc2626"
                            onClick={onClose}
                            descriptionKey="interactionDescriptions:components.confirmationPopup.confirmationPopup.button.cancel"
                          />
                        </div>
                      </>
                    }
                  />
                </>
              }
            />
          </div>
        </Animate>
      </div>
    </ModalPortal>
  )
}
